require('./filter-value-input.component.scss');

export class FilterValueInputController {
  constructor($scope, $element, $http, rx, observeOnScope, CurrentModelService) {
    this.$scope = $scope;
    this.$element = $element;
    this.$http = $http;
    this.rx = rx;
    this.CurrentModelService = CurrentModelService;
    this.filteredSuggestions = [];
    this.suggestions = [];
    this.subscriptions = [
      rx.Observable.merge(
        observeOnScope($scope, '$ctrl.dimension'),
        observeOnScope($scope, '$ctrl.hierarchy'),
      )
        .filter(value => value)
        .debounce(200)
        .do(() => {
          this.loading = true;
          this.suggestions = [];
          $scope.$digest();
        })
        .switchMap(() => this.getSuggestions())
        .do(() => {
          this.loading = false;
        })
        .subscribe(
          (suggestions) => {
            this.suggestions = suggestions;
            this.filterSuggestions();
            $scope.$digest();
          },
          (error) => {
            console.error(error);
            this.loading = false;
            $scope.$digest();
          },
        ),
    ];
    this.error = false;
  }

  $onInit() {
  }

  $onDestroy() {
    this.subscriptions.forEach((s) => s.dispose());
  }

  setValue(suggestion) {
    const cellFilter = this.CurrentModelService.model.getCellFilter(
      this.fullDimension,
      suggestion,
    );
    this.value = cellFilter.value;
    this.label = cellFilter.label;
  }

  getDropdownLabel(suggestion) {
    return suggestion.dropdownLabel || (suggestion.dropdownLabel =
      this.CurrentModelService.model.getCellLabel(this.fullDimension, suggestion));
  }

  getSuggestions() {
    return this.rx.Observable.fromPromise(this.$http.get(
      `/analytics/values/${this.CurrentModelService.cube.name}/?drill=${this.fullDimension}`))
      .map((suggestions) => suggestions.data.cells)
      ;
  }

  onFocus() {
    this.focused = true;
    this.isOpen = true;
  }

  onBlur() {
    this.focused = false;
    this.isOpen = false;
    if (this.value === '') {
      if (this.filteredSuggestions.length) {
        this.setValue(this.filteredSuggestions[0]);
      } else {
      }
    }
  }

  get fullDimension() {
    return this.CurrentModelService.model.getHierarchy(
      `${this.dimension}@${this.hierarchy}`).toString();
  }

  filterSuggestions() {
    this.filteredSuggestions = this.label ?
      this.suggestions.filter(suggestion =>
        this.getDropdownLabel(suggestion).startsWith(
          this.label)) : this.suggestions;
  }
}

export const FilterValueInputComponent = {
  bindings  : {
    value: '=',
    label: '=',
    dimension: '<',
    multiple: '<',
    hierarchy: '<',
  },
  template  : require('./filter-value-input.component.html'),
  controller: FilterValueInputController,
};



// WEBPACK FOOTER //
// ./src/filter/query-builder/filter-value-input.component.js